<!--
 * @Description: 首页容器
 * @Autor: WangYuan
 * @Date: 2021-06-10 16:20:52
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-04-20 11:00:05
-->
<template>
  <div class="main">

    <!-- 侧边菜单 -->
    <ul class="main-meau">
      <img
        class="w40 auto-center mt10 mb30 radius"
        :src="project?.logo || ''"
      >
      <template v-for="(item,index) in meauList">
        <router-link :to="{path: item.path}" v-if="!item.hide || !isSubAccount">
          <li class="main-meau-item">
            <i
              class="icon"
              :class="item.icon"
            ></i>
            <span>{{item.name}}</span>
          </li>
        </router-link>
      </template>
    </ul>

    <!-- 内容 -->
    <div class="main-body">
      <top-bar></top-bar>
      <div class="main-body-content">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import { mapMutations, mapGetters } from "vuex";
import { settingProject } from "@/utils/auth";

export default {
  name: "mall",

  components: {
    TopBar,
  },

  created() {
    // 默认设置首页为当前正在构建页面
    this.initHomePage();

    // 利用闭包保存project数据,在刷新时保存
    let temp = this.project;

    // 当页面刷新时，把当前项目数据保存localStorage中
    window.addEventListener("beforeunload", function (e) {
      settingProject(temp);
    });
  },

  data() {
    return {
      meauList: [
        {
          name: "站点配置",
          // icon: "icon-shop",
          path: "/mall/store",
        },
        {
          name: "直播管理",
          // icon: "icon-file",
          path: "/mall/live",
        },
        {
          name: "微站管理",
          // icon: "icon-fuzhiyemian",
          path: "/mall/pages-manage",
        },
        {
          name: "页面搭建",
          // icon: "icon-list",
          path: "/mall/page-build",
        },
        {
          name: "素材管理",
          // icon: "icon-folder",
          path: "/mall/material-center",
        },
        {
          name: "用户管理",
          // icon: "icon-list",
          path: "/mall/user",
        },
        {
          name: "嘉宾管理",
          // icon: "icon-user",
          path: "/mall/guest",
        },
        {
          name: "日程管理",
          // icon: "icon-calendar",
          path: "/mall/schedule",
        },
        {
          name: "权限管理",
          // icon: "icon-lock",
          path: "/mall/permission",
          hide: true,
        },
        // {
        //   name: "商城",
        //   icon: "icon-list",
        //   path: "/mall/goods",
        // },
        // {
        //   name: "模板",
        //   icon: "icon-list",
        //   path: "/mall/model-manage",
        // },
      ],
    };
  },

  computed: {
    ...mapGetters(["project", "userInfo"]),
    isSubAccount() {
      return this.userInfo && this.userInfo.isSubAccount
    }
  },

  methods: {
    ...mapMutations(["initHomePage"]),
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  height: 100vh; /*no*/
  background: #f7f8fa;

  .main-body {
    flex: 1;

    .main-body-content {
      position: relative;
      height: calc(100% - 60px); /*no*/
      margin-top: 4px;
      overflow: hidden;
    }
  }
}

.main-meau {
  width: 120px; /*no*/
  height: 100%;
  padding-top: 16px; /*no*/
  border-right: 1px solid #ebedf0; /*no*/
  // background: #22242f;
  background: #fff;

  .main-meau-item {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 14px; /*no*/
    padding: 11px 20px;
    color: #7d7e80;
    cursor: pointer;

    i {
      margin-right: 5px;
      font-size: 18px; /*no*/
      color: #7d7e80;
    }
  }

  .active {
    i {
      color: $color-theme !important;
    }
    .main-meau-item {
      position: relative;
      color: $color-theme !important;

      &::after {
        position: absolute;
        top: 10px; /*no*/
        right: 10px; /*no*/
        content: "";
        width: 4px; /*no*/
        height: 21px; /*no*/
        border-radius: 3px; /*no*/
        background: $color-theme;
      }
    }
  }
}
</style>